module.exports = __webpack_public_path__ + "img/icon-sb-white-glove-mob.64ea07e.svg";